import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/6a7aca54df0b4400143559f9_1786441374164_aafbdadb/alliswellexperience/src/app/lab-report/components/LabReportContent.tsx");
